// Estado padrão para criação de nova atividade PJ
export const defaultBeneficiaryFieldsPj = [
  // Campos obrigatórios (sempre visíveis e obrigatórios)
  { key: "taxPayerId", label: "CPF do titular", visible: true, mandatory: true },
  { key: "name", label: "Nome do titular", visible: true, mandatory: true },
  { key: "legalEntityId", label: "CNPJ do titular PJ", visible: true, mandatory: true },

  // Campos opcionais - Dados pessoais
  { key: "email", label: "Email", visible: false, mandatory: false },
  { key: "plan", label: "Plano", visible: false, mandatory: false },
  { key: "phoneNumber", label: "Telefone", visible: false, mandatory: false },
  { key: "race", label: "Raça", visible: false, mandatory: false },
  { key: "educationLevel", label: "Escolaridade", visible: false, mandatory: false },
  { key: "nationalityCountry", label: "Nacionalidade", visible: false, mandatory: false },
  { key: "birthCountry", label: "País de nascimento", visible: false, mandatory: false },
  { key: "birthState", label: "Estado de nascimento", visible: false, mandatory: false },
  { key: "birthCity", label: "Cidade de nascimento", visible: false, mandatory: false },
  { key: "motherName", label: "Nome da mãe", visible: false, mandatory: false },
  { key: "gender", label: "Gênero", visible: false, mandatory: false },
  { key: "birthDate", label: "Data de nascimento", visible: false, mandatory: false },
  { key: "hiringDate", label: "Data de contratação", visible: false, mandatory: false },
  { key: "maritalStatus", label: "Estado civil", visible: false, mandatory: false },
  { key: "weddingDate", label: "Data de casamento", visible: false, mandatory: false },

  // Campos de documentos
  { key: "nationalIdentityNumber", label: "RG", visible: false, mandatory: false },
  { key: "nationalIdentityEmissor", label: "Órgão emissor RG", visible: false, mandatory: false },
  { key: "nationalIdentityExpeditionDate", label: "Data expedição RG", visible: false, mandatory: false },

  // Campos de endereço
  { key: "zipCode", label: "CEP", visible: false, mandatory: false },
  { key: "addressType", label: "Tipo de endereço", visible: false, mandatory: false },
  { key: "address", label: "Endereço", visible: false, mandatory: false },
  { key: "addressNumber", label: "Número", visible: false, mandatory: false },
  { key: "complement", label: "Complemento", visible: false, mandatory: false },
  { key: "neighborhood", label: "Bairro", visible: false, mandatory: false },
  { key: "state", label: "Estado", visible: false, mandatory: false },
  { key: "city", label: "Cidade", visible: false, mandatory: false },

  // Campos novos adicionados
  { key: "status", label: "Status", visible: false, mandatory: false },
  { key: "jobTitle", label: "Cargo", visible: false, mandatory: false },
  { key: "registrationNumber", label: "Matrícula", visible: false, mandatory: false },
  { key: "paymentFrequency", label: "Frequência de pagamento", visible: false, mandatory: false },
  { key: "grossPayment", label: "Salário bruto", visible: false, mandatory: false },
  { key: "municipality", label: "Município", visible: false, mandatory: false },
  { key: "cbo", label: "CBO", visible: false, mandatory: false },
] as const;

// Estado padrão para criação de nova atividade CLT (todos os campos iguais exceto CNPJ)
export const defaultBeneficiaryFieldsClt = [
  // Campos obrigatórios (sempre visíveis e obrigatórios) - SEM legalEntityId
  { key: "taxPayerId", label: "CPF do titular", visible: true, mandatory: true },
  { key: "name", label: "Nome do titular", visible: true, mandatory: true },

  // Campos opcionais - Dados pessoais
  { key: "email", label: "Email", visible: false, mandatory: false },
  { key: "plan", label: "Plano", visible: false, mandatory: false },
  { key: "phoneNumber", label: "Telefone", visible: false, mandatory: false },
  { key: "race", label: "Raça", visible: false, mandatory: false },
  { key: "educationLevel", label: "Escolaridade", visible: false, mandatory: false },
  { key: "nationalityCountry", label: "Nacionalidade", visible: false, mandatory: false },
  { key: "birthCountry", label: "País de nascimento", visible: false, mandatory: false },
  { key: "birthState", label: "Estado de nascimento", visible: false, mandatory: false },
  { key: "birthCity", label: "Cidade de nascimento", visible: false, mandatory: false },
  { key: "motherName", label: "Nome da mãe", visible: false, mandatory: false },
  { key: "gender", label: "Gênero", visible: false, mandatory: false },
  { key: "birthDate", label: "Data de nascimento", visible: false, mandatory: false },
  { key: "hiringDate", label: "Data de contratação", visible: false, mandatory: false },
  { key: "maritalStatus", label: "Estado civil", visible: false, mandatory: false },
  { key: "weddingDate", label: "Data de casamento", visible: false, mandatory: false },

  // Campos de documentos
  { key: "nationalIdentityNumber", label: "RG", visible: false, mandatory: false },
  { key: "nationalIdentityEmissor", label: "Órgão emissor RG", visible: false, mandatory: false },
  { key: "nationalIdentityExpeditionDate", label: "Data expedição RG", visible: false, mandatory: false },

  // Campos de endereço
  { key: "zipCode", label: "CEP", visible: false, mandatory: false },
  { key: "addressType", label: "Tipo de endereço", visible: false, mandatory: false },
  { key: "address", label: "Endereço", visible: false, mandatory: false },
  { key: "addressNumber", label: "Número", visible: false, mandatory: false },
  { key: "complement", label: "Complemento", visible: false, mandatory: false },
  { key: "neighborhood", label: "Bairro", visible: false, mandatory: false },
  { key: "state", label: "Estado", visible: false, mandatory: false },
  { key: "city", label: "Cidade", visible: false, mandatory: false },

  // Campos novos adicionados
  { key: "status", label: "Status", visible: false, mandatory: false },
  { key: "jobTitle", label: "Cargo", visible: false, mandatory: false },
  { key: "registrationNumber", label: "Matrícula", visible: false, mandatory: false },
  { key: "paymentFrequency", label: "Frequência de pagamento", visible: false, mandatory: false },
  { key: "grossPayment", label: "Salário bruto", visible: false, mandatory: false },
  { key: "municipality", label: "Município", visible: false, mandatory: false },
  { key: "cbo", label: "CBO", visible: false, mandatory: false },
] as const;
